import React from 'react';

import { Container, Content, Message, Link } from './styles';

const NotFoundAdmin = () => {
  return (
    <Container>
      <Content>
        <Message>404</Message>
        <Link to="/admin">Ir para Dashboard</Link>
      </Content>
    </Container>
  );
};

export default NotFoundAdmin;
